import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  topBar: {
    width: '100%',
    height: 'auto',
    background: 'white',
    padding: '12px 16px',
    border: 'none',
    boxShadow: 'none',
    display: 'flex',
    justify: 'space-between',
    alignItems: 'center',
  },
  topBarRadius: {
    borderBottomRightRadius: '33px',
    borderBottomLeftRadius: '33px',
  },
  topBarContent: {
    display: 'flex',
    justify: 'flex-end',
    alignItems: 'center',
  },
  logoWrapper: {
    height: 'auto',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flex: 1,
    paddingRight: 16,
  },
  logo: {
    width: '100%',
    maxHeight: 40,
    objectFit: 'contain',
    objectPosition: 'left center',
  },
  logoContainer: {
    maxWidth: 200,
    height: 'auto',
  },
}))

export default useStyles
